import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllContractTerms } from "../../../../../redux/contractSlice/contractSlice";
import Select from "react-select";

export default function TermsSection({ terms, setTerms }) {
  const dispatch = useDispatch();
  const { allContractTerms } = useSelector((state) => state.contract);

  useEffect(() => {
    dispatch(getAllContractTerms());
  }, [dispatch]);

  const termsOptions =
    allContractTerms &&
    allContractTerms.length > 0 &&
    allContractTerms.map((term) => ({
      value: term?.id,
      label: term?.title,
    }));

  const handleTermChange = (index, field, value) => {
    if (field === "selectedTerm") {
      const selectedTerm = allContractTerms?.find((term) => term.id === value?.value);
      if (selectedTerm) {
        setTerms((prevTerms) =>
          prevTerms.map((term, i) =>
            i === index
              ? {
                  ...term,
                  title: selectedTerm.title,
                  description: selectedTerm.description,
                }
              : term
          )
        );
      }
    } else {
      setTerms((prevTerms) => prevTerms.map((term, i) => (i === index ? { ...term, [field]: value } : term)));
    }
  };

  const handleAddTerm = () => {
    setTerms((prevTerms) => [...prevTerms, { title: "", description: "" }]);
  };

  const handleRemoveTerm = (index) => {
    setTerms((prevTerms) => prevTerms.filter((_, i) => i !== index));
  };

  return (
    <>
      <div className="carousel-item">
        <div className="mt-5 pt-4">
          <form className="container">
            <h3 className="mb-3">شروط العقد</h3>
            <div>
              {terms
                .filter((term) => term.title !== "main")
                .map((term, index) => (
                  <div key={index} className="mb-3">
                    <Select options={termsOptions || []} placeholder="اختر البند" onChange={(selectedOption) => handleTermChange(index, "selectedTerm", selectedOption)} value={Array.isArray(termsOptions) && term?.title ? termsOptions.find((option) => option.label === term.title) || null : null} isClearable />{" "}
                    <label htmlFor={`term-title-${index}`} className="form-label mt-2">
                      عنوان البند
                    </label>
                    <input type="text" className="form-control" id={`term-title-${index}`} value={term.title} onChange={(e) => handleTermChange(index, "title", e.target.value)} />
                    <label htmlFor={`term-description-${index}`} className="form-label mt-2">
                      تفاصيل البند
                    </label>
                    <textarea className="form-control" id={`term-description-${index}`} value={term.description} onChange={(e) => handleTermChange(index, "description", e.target.value)} rows={3} />
                    <button type="button" className="btn btn-danger mt-2" onClick={() => handleRemoveTerm(index)}>
                      حذف البند
                    </button>
                  </div>
                ))}
              <button type="button" className="btn btn-primary mt-3" onClick={handleAddTerm}>
                + إضافة بند جديد
              </button>
            </div>
          </form>
        </div>
        <div className="d-flex justify-content-between mx-5 my-3">
          <button className="btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span>السابق</span>
          </button>
          <button className="btn btn-primary" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            التالي
          </button>
        </div>
      </div>
    </>
  );
}
